import { getStatusBarHeight } from '@/utils/nativeBridge.js'
import store from '@/store'
import utils from '@/utils/utils'
import { contactNum } from '@/config/common'
const { getUrlQuery } = utils

let scrollBarWidth
const bodyEl = document.body
let top = 0
export default {
  data () {
    return {
      statusHeight: '20'
    }
  },
  methods: {
    pxBack (pxNum) {
      const fontSize = document.documentElement.style.fontSize.replace('px', '')
      return (pxNum * 100) / fontSize
    },
    pxGo (pxNum) {
      const fontSize = document.documentElement.style.fontSize.replace('px', '')
      return (pxNum * fontSize) / 100
    },
    getStatusBarHeight () {
      getStatusBarHeight().then(data => {
        if (data && data.height) {
          this.statusHeight = data.height
        }
      })
    },
    getScrollBarWidth () {
      if (scrollBarWidth !== undefined) return scrollBarWidth

      const outer = document.createElement('div')
      outer.style.visibility = 'hidden'
      outer.style.width = '100px'
      outer.style.position = 'absolute'
      outer.style.top = '-9999px'
      document.body.appendChild(outer)

      const widthNoScroll = outer.offsetWidth
      outer.style.overflow = 'scroll'

      const inner = document.createElement('div')
      inner.style.width = '100%'
      outer.appendChild(inner)

      const widthWithScroll = inner.offsetWidth
      outer.parentNode.removeChild(outer)

      return widthNoScroll - widthWithScroll
    },
    getContactNumber () {
      const region = getUrlQuery().area || store.region
      return contactNum[region]
    },
    stopBodyScroll (isFixed) {
      if (isFixed) {
        top = window.scrollY
        bodyEl.style.position = 'fixed'
        bodyEl.style.top = `${-top}px`
      } else {
        bodyEl.style.position = ''
        bodyEl.style.top = ''

        window.scrollTo(0, top) // 回到原先的top
      }
    }
  },
  mounted () {
    this.getStatusBarHeight()
  }
}
